/* MODI - image-hotspot mobile behaviour (2026-07-29, rev 3).
   The theme keeps every hotspot label permanently visible. On a ~345px wide
   mobile image the long Georgian labels collided into an unreadable stack.
   On mobile we collapse them: the photo shows only the dots, and tapping a dot
   reveals that one label while closing any other, so an overlap is impossible.
   Desktop is untouched. If this script never runs the section renders exactly
   as the theme shipped it - all of the CSS is scoped to .modi-tap, which is
   only ever added from here. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 47.99em)';
  var EDGE = 4; // px of breathing room to keep inside the image
  var openSpot = null;

  function labelOf(spot) {
    return spot.querySelector('.hotspots__label');
  }

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function close(spot) {
    if (!spot) return;
    spot.classList.remove('is-open', 'modi-flip');
    var label = labelOf(spot);
    if (label) label.style.maxInlineSize = '';
    var button = spot.querySelector('.hotspots__button');
    /* Only report collapsed state where the control can actually collapse -
       on desktop the label is permanently visible and aria-expanded would lie. */
    if (button && button.hasAttribute('aria-expanded')) {
      button.setAttribute('aria-expanded', 'false');
    }
    if (openSpot === spot) openSpot = null;
  }

  /* Keep a revealed label inside the image: .media-banner__inner clips
     overflow, so a label running past the edge would be cut in half. */
  function place(spot) {
    var wrapper = spot.closest('.hotspots__wrapper');
    var label = labelOf(spot);
    if (!wrapper || !label) return;

    var bounds = wrapper.getBoundingClientRect();
    var rect = label.getBoundingClientRect();

    if (rect.right > bounds.right - EDGE || rect.left < bounds.left + EDGE) {
      spot.classList.add('modi-flip');
      rect = label.getBoundingClientRect();
    }

    var trim = Math.max(
      rect.right - (bounds.right - EDGE),
      bounds.left + EDGE - rect.left,
      0
    );
    if (trim > 0) {
      label.style.maxInlineSize = Math.max(88, rect.width - trim) + 'px';
    }
  }

  function open(spot) {
    if (openSpot && openSpot !== spot) close(openSpot);
    spot.classList.add('is-open');
    var button = spot.querySelector('.hotspots__button');
    if (button) button.setAttribute('aria-expanded', 'true');
    openSpot = spot;
    place(spot);
  }

  function toggleFrom(button, event) {
    var wrapper = button.closest('.hotspots__wrapper');
    if (!wrapper || !wrapper.classList.contains('modi-tap')) return;

    var spot = button.closest('.hotspots__hotspot');
    if (!spot) return;

    if (spot.classList.contains('is-open')) {
      /* Second tap on a hotspot that links somewhere follows the link. */
      if (button.tagName === 'A' && button.getAttribute('href')) return;
      event.preventDefault();
      close(spot);
      return;
    }

    event.preventDefault();
    open(spot);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('.hotspots__button') : null;
    if (!button) {
      if (openSpot) close(openSpot);
      return;
    }
    toggleFrom(button, event);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var target = event.target;
    var button = target && target.closest ? target.closest('.hotspots__button') : null;
    if (!button || button.tagName === 'A') return;
    toggleFrom(button, event);
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && openSpot) close(openSpot);
  });

  function sync() {
    var mobile = isMobile();
    var wrappers = document.querySelectorAll('.hotspots__wrapper');

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      Array.prototype.forEach.call(
        wrapper.querySelectorAll('.hotspots__hotspot'),
        function (spot) {
          var button = spot.querySelector('.hotspots__button');
          if (!button) return;

          /* The label is the button's only text, so once it is collapsed the
             control would be nameless for screen readers. Pin the name. */
          var label = labelOf(spot);
          if (label && !button.getAttribute('aria-label')) {
            button.setAttribute(
              'aria-label',
              label.textContent.replace(/\s+/g, ' ').trim()
            );
          }
          if (button.tagName !== 'A' && !button.hasAttribute('role')) {
            button.setAttribute('role', 'button');
            button.setAttribute('tabindex', '0');
          }

          if (mobile) {
            if (!button.hasAttribute('aria-expanded')) {
              button.setAttribute('aria-expanded', 'false');
            }
          } else {
            close(spot);
            button.removeAttribute('aria-expanded');
          }
        }
      );

      wrapper.classList.toggle('modi-tap', mobile);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  var mq = window.matchMedia(MOBILE);
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }

  document.addEventListener('shopify:section:load', sync);
})();
